var exports = {
  "B$": "x805b157e--3bc93f--gallery-container",
  "f8": "x805b157e--3bc93f--wrap-container",
  "_W": "x805b157e--3bc93f--main-page-style",
  "d$": "x805b157e--3bc93f--desktop-style",
};

module.exports = exports;
